<template>
  <v-expansion-panel style="border-radius: 6px">
    <v-expansion-panel-header
      style="font-weight: 600; color: #746b6b; font-size: 12x"
    >
      {{ $t("events.event-config.sales-period") }}
    </v-expansion-panel-header>
    <v-expansion-panel-content class="py-6">
      <v-row>
        <v-col cols="12">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                required
                readonly
                :label="$t('events.event-config.init-date')"
                type="tel"
                v-model="$produtos_gerenciar.cadastro.periodo_vendas.initDate"
                v-bind="attrs"
                v-on="on"
                placeholder="dd/mm/aaaa"
                v-mask="'##/##/####'"
                append-icon="mdi-calendar-outline"
                :rules="[rules.required]"
                :validate-on-blur="false"
              >
              </BaseTextField>
            </template>
            <v-date-picker
              v-model="$produtos_gerenciar.cadastro.periodo_vendas.data_inicio"
              :active-picker.sync="activePicker"
              :min="minInitDate"
              @change="save"
              locale="pt"
              :color="$config.dados.corinputs"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12">
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                required
                :label="$t('events.event-config.init-hour')"
                type="tel"
                v-bind="attrs"
                readonly
                v-on="on"
                placeholder="hh:mm"
                v-mask="'##:##'"
                append-icon="mdi-clock-outline"
                v-model="$produtos_gerenciar.cadastro.periodo_vendas.initHour"
                :rules="[rules.required]"
                :validate-on-blur="false"
              >
              </BaseTextField>
            </template>
            <v-time-picker
              v-model="$produtos_gerenciar.cadastro.periodo_vendas.hora_inicio"
              :active-picker.sync="activePicker2"
              @change="save2"
              locale="pt"
              scrollable
              format="24hr"
              color="secondary"
              range
            >
            </v-time-picker>
          </v-menu>
        </v-col>
        <v-col cols="12">
          <v-menu
            ref="menu3"
            v-model="menu3"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                required
                :label="$t('events.event-config.end-date')"
                v-model="$produtos_gerenciar.cadastro.periodo_vendas.endDate"
                type="tel"
                readonly
                v-bind="attrs"
                v-on="on"
                placeholder="dd/mm/aaaa"
                v-mask="'##/##/####'"
                append-icon="mdi-calendar-outline"
                :rules="[rules.required]"
                :validate-on-blur="false"
              >
              </BaseTextField>
            </template>
            <v-date-picker
              v-model="$produtos_gerenciar.cadastro.periodo_vendas.data_termino"
              :active-picker.sync="activePicker3"
              :min="minEndDate"
              no-title
              scrollable
              @change="save3"
              locale="pt"
              :color="$config.dados.corinputs"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12">
          <v-menu
            ref="menu4"
            v-model="menu4"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                required
                :label="$t('events.event-config.end-hour')"
                type="tel"
                v-bind="attrs"
                readonly
                v-on="on"
                placeholder="hh:mm"
                v-mask="'##:##'"
                append-icon="mdi-clock-outline"
                v-model="$produtos_gerenciar.cadastro.periodo_vendas.endHour"
                :rules="[rules.required]"
                :validate-on-blur="false"
              >
              </BaseTextField>
            </template>
            <v-time-picker
              v-model="$produtos_gerenciar.cadastro.periodo_vendas.hora_termino"
              :active-picker.sync="activePicker4"
              @change="save4"
              locale="pt"
              format="24hr"
              scrollable
              header-color="secondary"
              color="secondary"
              range
            >
            </v-time-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import dayjs from "dayjs";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import products from "@/mixins/products.js";
import mixins from "@/mixins";

const { formRules } = mixins;
export default {
  name: "SalesPeriod",
  mixins: [products, formRules],
  components: {
    BaseTextField,
  },
  data() {
    return {
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      activePicker: null,
      activePicker2: null,
      activePicker3: null,
      activePicker4: null,
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "MONTH"));
      this.menu === false && !this.activePicker2 ? (this.menu2 = true) : null;
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "HOUR"));
      this.menu2 === false && !this.activePicker3 ? (this.menu3 = true) : null;
    },
    menu3(val) {
      val && setTimeout(() => (this.activePicker3 = "MONTH"));
      this.menu3 === false && !this.activePicker4 ? (this.menu4 = true) : null;
    },
    menu4(val) {
      val && setTimeout(() => (this.activePicker4 = "HOUR"));
    },
  },
  computed: {
    minInitDate() {
      return dayjs().format("YYYY-MM-DD");
    },
    minEndDate() {
      return dayjs(this.$produtos_gerenciar.cadastro.periodo_vendas.data_inicio)
        .add(1, "day")
        .format("YYYY-MM-DD");
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
      this.$produtos_gerenciar.cadastro.periodo_vendas.initDate =
        dayjs(date).format("DD/MM/YYYY");
    },
    save2(hour) {
      this.$refs.menu2.save(hour);
      this.$produtos_gerenciar.cadastro.periodo_vendas.initHour = hour;
    },
    save3(date) {
      this.$refs.menu3.save(date);
      this.$produtos_gerenciar.cadastro.periodo_vendas.endDate =
        dayjs(date).format("DD/MM/YYYY");
    },
    save4(hour) {
      this.$refs.menu4.save(hour);
      this.$produtos_gerenciar.cadastro.periodo_vendas.endHour = hour;
    },
  },
};
</script>

<style scoped>
.v-application .accent--text {
  color: none !important;
}
</style>
